const STYLES = {
  submitted: "border-sky-400/50 text-sky-200 bg-sky-500/10",
  under_review: "border-amber-400/50 text-amber-300 bg-amber-500/10",
  awaiting_info: "border-orange-400/50 text-orange-300 bg-orange-500/10",
  actioned: "border-[#83B68B]/50 text-[#83B68B] bg-[#83B68B]/10",
  closed: "border-border opacity-60",
};

export function StatusChip({ status, labels = {} }) {
  return (
    <span data-testid={`status-chip-${status}`} className={`text-[9px] tracking-widest uppercase px-2 py-0.5 rounded border ${STYLES[status] || "border-border"}`}>
      {labels[status] || status}
    </span>
  );
}
